import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const BillingFlagKey = {
  RELEASE_LOCAL_CURRENCY_BILLING: featureFlagKey(
    "release-local-currency-billing",
  ), // Bill opted-in merchants in their local currency; off = bills stay USD
  MERCURY_OFFER_BILLING_PAGE: featureFlagKey("mercury-offer-billing-page"), // Show the Mercury partner offer card on the merchant billing page
  REV_SHARE_COVERAGE_LINE_ITEM: featureFlagKey("rev-share-coverage-line-item"), // Emit coverage payouts as gross + negative rev-share offset (net unchanged)
} as const;
